import React, { FC } from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { ReportConfigDto } from '@thingslog/repositories';

interface TransmissionReportSettingsFormProps {
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const TransmissionReportSettingsForm: FC<
  TransmissionReportSettingsFormProps
> = (): React.ReactElement | null => {
  // No additional settings for transmission report
  return null;
};

export default TransmissionReportSettingsForm;
